
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalItemsSelectGrid extends _Ext.GridBase<POSApprovalItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalItems'; }
        protected getDialogType() { return POSApprovalItemsDialog; }
        protected getIdProperty() { return POSApprovalItemsRow.idProperty; }
        protected getInsertPermission() { return POSApprovalItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalItemsRow.localTextPrefix; }
        protected getService() { return POSApprovalSelectItemsService.baseUrl; }
        protected getInitialTitle() { return null; };

        private autoSize;  
        withBom: boolean;
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container,options);


            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as TransactionRequest).PartyId = poscustomerid;
                //(this.view.params as TransactionRequest).InStock = ECommPOSApprovalItemsSelectGrid.InStock;
            }
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): POSApprovalItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}